// extracted by mini-css-extract-plugin
export default {"asideRouterCard":"index_asideRouterCard__H6nMF"};